import React, {useEffect, useState, useRef, useCallback} from 'react';
import {Range} from 'rc-slider';
import {useRouter} from 'next/router';

import {pageUrl} from '@utils/product';
import {useApp} from '@context/AppProvider';

let priceFilter = null;

function Price(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

function Desktop(props) {
	const {styles} = props;
	const router = useRouter();
	const [collapse, setCollapse] = useState(
		props.filters.price_from ? true : false,
	);
	const sliderRef = useRef({});
	const onChange = (min, max, time = 1000) => {
		let query = {...props.filters};
		// eslint-disable-next-line babel/camelcase
		query.price_from = min;
		// eslint-disable-next-line babel/camelcase
		query.price_to = max;

		delete query.page;
		if (priceFilter) clearInterval(priceFilter);
		priceFilter = setInterval(() => {
			router.push({
				pathname: pageUrl(props),
				query,
			});
			clearInterval(priceFilter);
		}, time);
	};

	const updateSetCollapse = useCallback(status => {
		if (!status) {
			sliderRef.current.style.height =
				sliderRef.current.parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current.style.height = '0px';
				setCollapse(status);
			}, 10);
		} else {
			sliderRef.current.style.height = 'auto';
			setCollapse(status);
		}
	}, []);

	useEffect(() => {
		updateSetCollapse(props.filters.price_from ? true : false);
	}, [props.filters, updateSetCollapse]);

	const min = +props.filters.price_from || 0;
	const max = +props.filters.price_to || 10000;

	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`${styles.cardHeader}`}>
				<span
					className='card-link'
					data-toggle='collapse'
					aria-expanded={collapse}
					onClick={() => {
						updateSetCollapse(!collapse);
					}}
				>
					Price
				</span>
			</div>
			<div ref={sliderRef} className={`collapse ${collapse && 'show'}`}>
				<Slider styles={styles} min={min} max={max} onChange={onChange} />
			</div>
		</div>
	);
}

function Mobile(props) {
	const {styles} = props;

	const onChange = (min, max, time = 0, error) => {
		let query = {};
		// eslint-disable-next-line babel/camelcase
		query.price_from = min;
		// eslint-disable-next-line babel/camelcase
		query.price_to = max;
		query.error = error;
		setTimeout(() => {
			props.setFilter(query);
		}, time);
	};
	const min = props.params.price_from || 1;
	const max = props.params.price_to || 10000;

	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`collapse show`}>
				<Slider
					styles={styles}
					min={min}
					max={max}
					type='mobile'
					onChange={onChange}
				/>
			</div>
		</div>
	);
}

function Slider(props) {
	const {convertCurrency} = useApp();
	const {styles, min, max, type, onChange} = props;
	const [price, setPrice] = useState({min: 0, max: 10000, error: null});
	const updatePrice = event => {
		event.preventDefault();
		if (!price.update) return;
		if (price.min <= price.max && price.max >= price.min && !price.error) {
			onChange(price.min, price.max, 10);
		} else {
			if (type && type === 'mobile') {
				onChange(price.min, price.max, 10, price.error);
			}
		}
		setPrice(val => ({
			...val,
			update: false,
		}));
	};
	const updatePriceInput = event => {
		if (event.target.value > 10000) {
			setPrice(val => ({
				...val,
				error: 'Min or Max price cannot be greator than ' + 10000,
				update: true,
			}));
			return;
		}
		setPrice(val => ({
			...val,
			[event.target.name]: event.target.value,
			error: null,
			update: true,
		}));
	};

	useEffect(() => {
		setPrice({
			min,
			max,
		});
	}, [min, max]);

	useEffect(() => {
		let error = null;
		if (price.min < price.max && price.max > price.min && price.min >= 0) {
			if (price.min === '' || price.max === '') {
				error = 'Min or Max price cannot be empty.';
			}
			if (price.max > 10000) {
				error = 'Min or Max price cannot be greator than ' + 10000;
			}
		} else {
			if (price.min === '' || price.max === '') {
				error = 'Min or Max price cannot be empty.';
			}

			if (+price.min < 0) {
				error = 'Min price cannot be less than 0.';
			}
			if (+price.min > +price.max) {
				error = 'Min price cannot be greater than max price.';
			}
			if (+price.max > 10000) {
				error = 'Min or Max price cannot be greator than ' + 10000;
			}
		}

		if (error) {
			setPrice(val => ({
				...val,
				error,
			}));
		}
	}, [price.min, price.max]);

	const onChangeSlider = (min, max) => {
		setPrice({
			min,
			max,
		});

		onChange(min, max);
	};
	const currencySymbol = convertCurrency(0, false, true, false);
	return (
		<div className={`${styles.priceFilter}`}>
			<form onSubmit={e => updatePrice(e)}>
				{price.error && <span className='text-danger mb-2'>{price.error}</span>}
				<div className={styles.priceBox}>
					<input type='submit' hidden />
					<div
						className={`${styles.priceCard} input-group input-group-sm  mr-2`}
					>
						<div className='input-group-prepend'>
							<span className='input-group-text' id='basic-addon1'>
								{currencySymbol}
							</span>
						</div>
						<input
							name='min'
							value={price.min}
							min='0'
							max='10000'
							type='number'
							className={`${styles.priceInput} form-control`}
							onChange={e => updatePriceInput(e)}
							onBlur={e => updatePrice(e)}
						/>
					</div>
					<div className={`${styles.priceCard} input-group input-group-sm `}>
						<div className='input-group-prepend'>
							<span className='input-group-text' id='basic-addon1'>
								{currencySymbol}
							</span>
						</div>
						<input
							name='max'
							value={price.max}
							min='0'
							max='10000'
							type='number'
							className={`${styles.priceInput} form-control`}
							onChange={e => updatePriceInput(e)}
							onBlur={e => updatePrice(e)}
						/>
					</div>
				</div>
			</form>
			<div className={styles.priceSlide}>
				<Range
					min={0}
					max={10000}
					value={[price.min, price.max]}
					onChange={val => onChangeSlider(val[0], val[1])}
				/>
			</div>
		</div>
	);
}

export default Price;
